// Shared primary navigation config
// Single source of truth for both BottomNavigation (mobile/tablet) and
// DesktopSidebar (desktop) so the two never drift out of sync.

import React from "react";
import {
  Home,
  Gamepad2,
  Heart,
  MessageCircle,
  User,
  Users,
} from "lucide-react";
import { Icon } from "../shared";

export interface NavigationItemConfig {
  id: string;
  label: string;
  icon: React.ReactNode;
  activeIcon?: React.ReactNode;
  route: string;
  hasNotification?: boolean;
  notificationCount?: number;
  isSpecial?: boolean;
  variant?: "primary" | "secondary";
}

export const navigationItems: NavigationItemConfig[] = [
  {
    id: "home",
    label: "Home",
    icon: <Icon icon={Home} size={24} />,
    activeIcon: <Icon icon={Home} size={24} variant="filled" />,
    route: "/social-feed",
    hasNotification: false,
  },
  {
    id: "heart-games",
    label: "Games",
    icon: <Icon icon={Gamepad2} size={24} />,
    activeIcon: <Icon icon={Gamepad2} size={24} variant="filled" />,
    route: "/heart-games",
    hasNotification: false,
  },
  {
    id: "swipe",
    label: "Swipe",
    icon: <Icon icon={Heart} size={24} />,
    activeIcon: <Icon icon={Heart} size={24} variant="filled" />,
    route: "/swipe",
    isSpecial: true,
    variant: "primary",
  },
  {
    id: "messaging",
    label: "Chat",
    icon: <Icon icon={MessageCircle} size={24} />,
    activeIcon: <Icon icon={MessageCircle} size={24} variant="filled" />,
    route: "/messaging",
    hasNotification: false,
  },
  {
    id: "profile",
    label: "Profile",
    icon: <Icon icon={User} size={24} />,
    activeIcon: <Icon icon={Users} size={24} variant="filled" />,
    route: "/profile/view",
  },
];

export const getActiveNavigationItem = (pathname: string): string => {
  if (pathname.startsWith("/social-feed")) return "home";
  if (pathname.startsWith("/heart-games")) return "heart-games";
  if (pathname.startsWith("/swipe")) return "swipe";
  if (pathname.startsWith("/messaging")) return "messaging";
  if (pathname.startsWith("/profile/view") || pathname.startsWith("/profile")) return "profile";
  if (pathname.startsWith("/dashboard") || pathname === "/") return "home";

  return "home";
};
